/**
 * The hold. While the substrate answers, you are inside cloud — not staring at a
 * spinner on black. The Atlas then parts these same clouds to reveal the World,
 * so the whole arrival is one continuous descent.
 */
export const CloudHold = () => (
  <div
    className="fixed inset-0 overflow-hidden"
    data-testid="cloud-hold"
    style={{ background: "linear-gradient(180deg, #f4f6f8 0%, #e7edf4 52%, #dde6ef 100%)" }}
  >
    <div className="cloud-hold-a absolute" style={{ inset: "-10%" }} />
    <div className="cloud-hold-b absolute" style={{ inset: "-10%" }} />
  </div>
);

export default CloudHold;
